import ActionTypes from "../enums/ActionTypes"

export function fetchAccessibleLicenceModules() {
  return {
    type: ActionTypes.ACCESSIBLE_LICENCE_MODULES_LIST_REQUEST,
  }
}
